"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconMarkersHeadquarter = function SvgIconMarkersHeadquarter(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "markers headquarter icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Markers Headquarter Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.166 19.28h7.668v5.729h3.834v-13.37h-3.834v3.82h-7.668v-3.82h-3.834v13.37h3.834z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.501 4c2.115 0 3.835 1.715 3.835 3.82v21.01c0 2.106-1.72 3.82-3.835 3.82h-4.666L24 44l-6.835-11.35h-4.666a3.832 3.832 0 01-3.834-3.82V7.82c0-2.105 1.72-3.82 3.834-3.82h23.004zm0 24.83V7.82H12.498v21.01h6.836L24 36.577l4.666-7.749h6.836z"
  }));
};

var _default = SvgIconMarkersHeadquarter;
exports.default = _default;